export default {
  asignacionSoporteQuirurgico: {
    base: 'asignacionsoportequirurgico',
    withoutReporte: 'asignacionsoportequirurgico/getasignacioneswithoutreporte',
    cambioEstado: 'asignacionsoportequirurgico/cambioestado',
    pedidos: 'asignacionsoportequirurgico/getpedidos',
  },
  autocompletes: {
    bodega: 'autocompletes/bodega',
    almacenByBodega: 'autocompletes/almacenbybodega',
    ubicacionByAlmacen: 'autocompletes/ubicacionbyalmacen',
    contenedorByUbicacion: 'autocompletes/contenedorbyubicacion',
    nomenclatura: 'autocompletes/nomenclatura',
    ciudad: 'autocompletes/ciudad',
    tipoIdentificacion: 'autocompletes/tipoidentificacion',
    heapVenta: 'autocompletes/heapventa',
    heapVentaTercero: 'autocompletes/heapventatercero',
    productosCompuestos: 'autocompletes/productoscompuestos',
    cliente: 'autocompletes/cliente',
    moneda: 'autocompletes/moneda',
    empleadoByRol: 'autocompletes/empleadobyrol',
    tiposAdjuntos: 'autocompletes/tiposadjuntos',
    pais: 'autocompletes/pais',
    proveedoresEmpleados: 'autocompletes/proveedoresempleados',
    centrosCostos: 'autocompletes/centroscostos',
  },
  eps: {
    base: 'eps',
  },
  subespecialidades: {
    base: 'subespecialidad',
    fellow: {
      base: 'subespecialidadfellow',
    },
  },
  fellow: {
    base: 'fellow',
  },
  universidad: {
    base: 'universidad',
  },
  especialidades: {
    base: 'especialidad',
    subEspecialidad: {
      base: 'especialidadsubespecialidad',
    }
  },
  images: {
    base: 'images',
  },
  tipoAfiliacion: {
    base: 'tipoafiliacion',
  },
  diagnostico: {
    base: 'diagnostico',
    producto: {
      base: 'diagnostico/productos',
    },
  },
  instituciones: {
    base: 'instituciones',
  },
  pacientes: {
    base: 'pacientes',
    adjuntos: {
      base: 'pacienteadjunto',
    },
  },
  cirujanos: {
    adjuntos: {
      base: 'cirujanoadjunto',
    },
    base: 'cirujanos',
    ciudades: {
      base: 'cirujanos/ciudades',
    },
    firma: {
      base: 'cirujanofirma'
    },
    instituciones: {
      base: 'cirujanoinstitucion',
    },
  },
  prepedidos: {
    adjuntos: {
      base: 'prepedidoadjunto',
    },
    imagenes: {
      base: 'prepedidoimagen',
    },
    base: 'prepedido',
    cambioEstado: 'prepedido/cambioestado',
    productoscompuestos: 'prepedido/productoscompuestos',
    productosTerminados: 'prepedido/productosterminados',
    servicios: 'prepedido/servicios',
  },
  reporteGasto: {
    adjuntos: {
      base: 'reportegastoadjunto',
    },
    base: 'reportegasto',
    createFactura: 'reportegasto/createfactura',
    getDocumentosFactura: 'reportegasto/getdocumentosfactura',
    bioseguridad: {
      base: 'reportegastobioseguridad',
    },
    bodegaInstitucion: {
      base: 'reportegastobodegainstitucion',
    },
    cambioEstado: 'reportegasto/cambioestado',
    composicion: 'reportegastocomposicion',
    imagenes: {
      base: 'reportegastoimagen',
    },
    firmas: {
      base: 'reportegastofirma',
    }
  },
  seguridad: {
    rol: {
      base: 'seguridad/rol',
      find: 'seguridad/rol/find',
      duplicate: 'seguridad/rol/duplicate',
    },
    permiso: {
      base: 'seguridad/permiso',
    },
    usuario: {
      base: 'seguridad/usuario',
      find: 'seguridad/usuario/find',
    },
  },
  user: {
    base: 'user',
  },
};
